import { QueryConfig } from "store/utils/query-config";

export const waHolidayNotificationWorkflowsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-initiatedAt"],
  },
};
